'use client';

import { createContext, useContext } from 'react';

/**
 * Variables of the current flow step, provided by CheckClientData.
 * Steps are rendered by the server page and reach the client as opaque (possibly lazy) nodes,
 * so their props can't be patched with cloneElement; they read the step data from here instead.
 */
export const StepDataContext = createContext<object | undefined>(undefined);

/**
 * Returns the current step variables, preferring an explicitly passed prop.
 *
 * @param {T} [stepData] - Step data passed as a prop, if any.
 * @return {T | undefined} The step variables.
 */
export const useStepData = <T extends object>(stepData?: T): T | undefined => {
  const contextStepData = useContext(StepDataContext) as T | undefined;
  return stepData ?? contextStepData;
};
